import { default as _Vue } from 'vue';
import { Store } from 'vuex';
import { AbstractService } from '@/plugins/podolib/lib/AbstractService';

import { Ability, AbilityBuilder } from '@casl/ability';
export { AbilityBuilder };

import { abilitiesPlugin, Can } from '@casl/vue';

// Middleware
import middleware from './middleware';

// Abilities
import routeAbilities from './abilities/routes.json';

// Service options type declaration
export type TOptions = {};

/**
 * @author Damien CORLER <d.corler@zhortech.com>
 * @since 1.0.0
 * @version 1.0.0
 */
export default class AclService extends AbstractService<TOptions, any> {
  public abilities!: Ability;

  public readonly middleware: any = middleware;

  /**
   * Initialize
   * @param options
   */
  constructor(options: TOptions) {
    super(options, 'acl');
  }

  /**
   * Initialize plugin
   */
  async init(Vue: typeof _Vue, store: Store<any>) {
    await super.init(Vue, store);

    this.abilities = new Ability(this.defautlAbilities);

    Vue.use(abilitiesPlugin, this.abilities);
    Vue.component('Can', Can);
  }

  updateAbilities(rules: any) {
    return this.abilities.update(rules);
  }

  resetAbilities() {
    return this.abilities.update(this.defautlAbilities);
  }

  get defautlAbilities() {
    return routeAbilities;
  }
}
